<template>
  <div class="container">
    <homeHeader title="需求登记反馈" :isShowProjectSelect="true" @changeSelect="changeSelect"></homeHeader>
    <div class="main">
      <div class="card">
        <!-- 按钮组 -->
        <div class="toolbar-dv">
          <toolBarBtn
            @changeSearchFormShow="changeSearchFormShow"
            :buttonVisible="buttonVisible"
            :moreButtonList="moreButtonList"
            :parentData="this"
            ref="toolBarBtn"
          ></toolBarBtn>
        </div>
        <!-- 查找面板 -->
        <div class="search-dv" v-show="searchFormVisible">
          <SearchForm
            ref="SearchForm"
            v-show="searchFormVisible"
            :searchVuePath="searchVuePath"
            :menuArgs="''"
            @search="sureSearch"
          ></SearchForm>
        </div>
        <!-- 主表信息 -->
        <div class="approve-table-dv">
          <!-- 菜单明细 -->
          <div class="menu-dv" :style="{ height: this.approveCardHeight }">
            <div class="table-dv">
              <vxe-grid
                ref="xTable"
                resizable
                :cell-style="tableCellStyle"
                :column-config="{ minWidth: '80px' }"
                :row-config="{ height: 60 }"
                :data="tableData"
                :showOverflow="true"
                size="mini"
                :mouse-config="{ area: true }"
                :tooltip-config="{
                  showAll: true,
                  theme: 'dark'
                }"
                :pager-config="tablePage"
                @page-change="handlePageChange"
                :seq-config="{
                  startIndex: (tablePage.currentPage - 1) * tablePage.pageSize
                }"
                highlight-hover-row
                highlight-current-row
                :height="tableHeight"
                :columns="gridColumnsMenu"
                @cell-dblclick="handleDblclick"
                @cell-menu="cellContextMenuEvent"
                :menu-config="{
                  body: { options: bodyMenus },
                  visibleMethod: visibleMethod
                }"
                :keyboard-config="{
                  isArrow: true,
                  isEnter: true,
                  isTab: true,
                  isClip: true,
                  enterToTab: true,
                  isEdit: true
                }"
                :clip-config="{
                  copyMethod: copyMethod
                }"
                @menu-click="contextMenuClickEvent"
                :scroll-y="{
                  mode: 'wheel'
                }"
              >
              </vxe-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- :updateForm="form" -->
    <AddOrSeeRequireModal
      :parentData="this"
      :modalType.sync="modalType"
      :updateId="modalId"
      @updateModalType="updateModalType"
      ref="AddOrSeeRequireModal"
    />
    <!-- 设置更新版本模态窗 -->
    <SetPlanModal ref="SetPlanModal" @sureHandler="setPlanSureBack"></SetPlanModal>
    <!-- 评价待处理模态窗 -->
    <AssessTodoModal ref="AssessTodoModal" :tableData.sync="tableDataTodo" />
    <!-- 期初导入模态窗 -->
    <ImportModal ref="ImportModal" @sureBack="importBack" />
    <!-- 期初导入模态窗 -->
    <SyncToCooperation ref="SyncToCooperation" />
    <!-- 设置更新批次 -->
    <SetBatchNumModal ref="SetBatchNumModal" :defaultVal="defaultBatchNum" @sureHandler="sureBackBatchNum" />
  </div>
</template>

<script>
import AddOrSeeRequireModal from './AddOrSeeRequireModal'
import SetPlanModal from './SetPlanModal'
import AssessTodoModal from './AssessTodoModal.vue'
import ImportModal from './import.vue'
import SyncToCooperation from './SyncToCooperation.vue'
import SetBatchNumModal from './SetBatchNumModal.vue'
export default {
  name: 'RequirementsGather',
  components: {
    AddOrSeeRequireModal,
    SetPlanModal,
    AssessTodoModal,
    ImportModal,
    SyncToCooperation,
    SetBatchNumModal
  },
  data() {
    return {
      id: 0,
      // 是否显示查询
      searchFormVisible: false,
      // 查询条件
      searchObjects: [],
      gridColumnsMenu: [],
      // 查询条件vuepath
      searchVuePath: 'RequirementsGather',
      // 正常状态下，需要加上表格距离card上下的margin
      topBottomMargin: 20,
      // 按钮组的可见性
      buttonVisible: {
        add: true, // 新增按钮是否显示
        update: false, // 修改按钮
        save: false, // 保存按钮是否显示
        delete: false, // 删除按钮是否显示
        refresh: true, // 刷新数据按钮是否显示
        lock: false, // 锁定按钮是否显示
        unlock: false, // 解锁按钮是否显示
        sort: false, // 排序按钮是否显示
        search: true, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      },
      // form: {
      // },
      // detailListBRoleEmployee: [],
      tableData: [],
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      // 模态窗类型
      modalType: '',
      // 模态窗id,用于修改单据
      modalId: 0,
      // 分页设置
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: this.tablePageConfig.pageSize,
        align: 'right',
        pageSizes: this.tablePageConfig.pageSizes,
        layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
        perfect: true
      },
      // 产品类型
      optionsValue: '',
      // 右键
      bodyMenus: [
        [
          {
            code: 'handleSetBatchNum',
            name: '设置更新批次'
          },
          {
            code: 'handleSetPlanVersionOn',
            name: '设置预计更新版本'
          },
          {
            code: 'handleSetPlanVersionOff',
            name: '取消设置预计更新版本'
          },
          {
            code: 'handleSetRealVersionOn',
            name: '设置实际更新版本'
          },
          {
            code: 'handleSetRealVersionOff',
            name: '取消设置实际更新版本'
          }
        ]
      ],
      // 右键缓存
      areas: {},
      colProperty: '',
      // 右键缓存id
      cellIdList: [],
      // 设置版本类型(实际、预计)
      setVersionType: '',
      // 拓展按钮
      moreButtonList: [],
      // 待评价数据
      tableDataTodo: [],
      // 设置更新批次默认值
      defaultBatchNum: ''
    }
  },
  mounted() {},
  created() {
    this.InitColumn()
    this.moreButtonList = [
      {
        name: '清空筛选',
        icon: 'el-icon-brush',
        visible: true,
        event: 'handleClearFilter'
      },
      {
        name: '期初导入',
        icon: 'iconfont fjyk-daoru-03-copy',
        visible: this.$store.state.userInfo.gangWei === '运维' || this.$store.state.userInfo.gangWei === '管理',
        event: 'handleImport'
      },
      {
        name: '同步至协作项目',
        icon: 'iconfont fjyk-sync',
        visible: this.$store.state.userInfo.gangWei === '运维' || this.$store.state.userInfo.gangWei === '管理',
        event: 'handleCloudSync'
      }
    ]
  },
  methods: {
    // 重写单元格复制取值的方法，将单元格复制到剪贴板
    copyMethod({ row, column }) {
      let arr = []
      let i = 0
      switch (column.property) {
        case 'userCompany':
        case 'recorder':
        case 'handleNote':
        case 'handler':
        case 'assessNote':
        case 'requirementDesc':
        case 'suggestedSolutions':
          arr = String(row[column.property])
            .split('!#!')
            .map(item => {
              i++
              return (arr.length === 1 && item === '' ? '' : i + '、') + item
            })
          return arr.join(' ')
        default:
          return row[column.property]
      }
    },
    // 清空筛选
    handleClearFilter() {
      this.$refs.xTable.clearFilter()
    },
    // 设置更新批次
    async sureBackBatchNum(batchNum) {
      const { data: res } = await this.$http.put('/Bugs/YKBug/batch-num', {
        idList: this.cellIdList,
        batchNum: batchNum
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success('设置成功!')
      this.list()
    },
    // 同步至协作项目
    handleCloudSync() {
      this.$refs.SyncToCooperation.formVisible = true
    },
    // 动态样式 - 主要用于区分版本是否更新
    tableCellStyle({ row }) {
      // 有实际更新版本时，显示绿色
      if (row['actualIssuedVersion']) {
        return {
          backgroundColor: '#2ed573'
        }
        // 无实际版本有预计更新版本时，显示黄色
      } else if (row['planIssuedVersion']) {
        return {
          backgroundColor: '#fffa65'
        }
        // 如果结果为不处理时，显示红色
      } else if (row['handleResult'] === '不处理') {
        return {
          backgroundColor: '#f56c6c',
          color: '#fff'
        }
        // 有处理日期时，显示蓝色
      } else if (this.ykDateFormat('yyyy-MM-dd', row['handleTime'])) {
        return {
          backgroundColor: '#70a1ff',
          color: '#fff'
        }
      }
    },
    // 导入成功后触发事件
    importBack() {
      this.list()
    },
    // 查找
    search() {
      this.searchFormVisible = !this.searchFormVisible
    },
    // 确认查找
    sureSearch(searchObjects) {
      const that = this
      that.searchObjects = searchObjects
      that.tablePage.currentPage = 1
      that.list()
    },
    // 期初导入
    handleImport() {
      this.$refs.ImportModal.isShow = true
    },
    // 设置版本返回值
    async setPlanSureBack(str) {
      if (this.setVersionType === '预计') {
        const { data: res } = await this.$http.put('/Bugs/YKBug/issues-plan', {
          idList: this.cellIdList,
          issuedVersion: str
        })
        if (!res.isSuccess) {
          this.$message.error(res.errorMessage)
          return false
        }
        this.$message.success(res.data)
        this.list()
      } else if (this.setVersionType === '实际') {
        const { data: res } = await this.$http.put('/Bugs/YKBug/issues-actual', {
          idList: this.cellIdList,
          issuedVersion: str
        })
        if (!res.isSuccess) {
          this.$message.error(res.errorMessage)
          return false
        }
        this.$message.success(res.data)
        this.list()
      }
    },
    // 按下右键缓存选中列
    cellContextMenuEvent({ column }) {
      // if (this.$store.state.userInfo.gangWei !== '客户') {
      this.areas = this.$refs.xTable.getCellAreas()
      this.colProperty = column.property
      this.cellIdList = []
      for (let area of this.areas) {
        for (let row of area.rows) {
          if (!this.cellIdList.includes(row.id)) {
            this.cellIdList.push(row.id)
          }
        }
      }
      // }
    },
    // 右键控制菜单方法
    visibleMethod({ options, column }) {
      // 显示之前处理按钮的操作权限
      options.forEach(list => {
        list.forEach(item => {
          if (column) {
            // 设置版本 只有运维管理员能操作
            if (
              [
                'handleSetRealVersionOff',
                'handleSetPlanVersionOn',
                'handleSetPlanVersionOff',
                'handleSetRealVersionOn'
              ].includes(item.code)
            ) {
              this.$store.state.userInfo.gangWei !== '客户' ? (item.visible = true) : (item.visible = false)
              // 设置批次号 只有公司为福州远控的才能操作
            } else if (item.code === 'handleSetBatchNum') {
              this.$store.state.userInfo.company === '福州远控' ? (item.visible = true) : (item.visible = false)
            }
          } else {
            item.visible = false
          }
        })
      })
      return true
    },
    // 右键确认
    async contextMenuClickEvent({ menu, row }) {
      // 设置预计版本
      if (menu.code === 'handleSetPlanVersionOn') {
        this.setVersionType = '预计'
        if (this.ykDateFormat('yyyy-MM-dd', row.handleTime)) {
          const date = this.$utils.getWhatMonth(row.handleTime, 1)
          this.$refs.SetPlanModal.form.date = this.ykDateFormat('yyyy-MM-', date) + '15'
        } else {
          this.$refs.SetPlanModal.form.date = ''
        }
        this.$refs.SetPlanModal.formVisible = true
        //  设置实际版本
      } else if (menu.code === 'handleSetRealVersionOn') {
        this.setVersionType = '实际'
        this.$refs.SetPlanModal.form.date = ''
        this.$refs.SetPlanModal.formVisible = true
        // 取消预计版本
      } else if (menu.code === 'handleSetPlanVersionOff') {
        const { data: res } = await this.$http.put('Bugs/YKBug/unissues-plan', {
          idList: this.cellIdList
        })
        if (!res.isSuccess) {
          this.$message.error(res.errorMessage)
          return false
        }
        this.$message.success(res.data)
        this.list()
        // 取消实际版本
      } else if (menu.code === 'handleSetRealVersionOff') {
        const { data: res } = await this.$http.put('/Bugs/YKBug/unissues-actual', {
          idList: this.cellIdList
        })
        if (!res.isSuccess) {
          this.$message.error(res.errorMessage)
          return false
        }
        this.$message.success(res.data)
        this.list()
      } else if (menu.code === 'handleSetBatchNum') {
        this.$refs.SetBatchNumModal.formVisible = true
      }
    },
    // 页面函数
    handlePageChange({ currentPage, pageSize }) {
      const that = this
      that.tablePage.currentPage = currentPage
      that.tablePage.pageSize = pageSize
      that.list()
    },
    // 切换产品类型
    changeSelect(type) {
      // 注意！每次切换必须缓存产品类型值，才能在保存和activated触发时取到当前选择的类型
      this.optionsValue = type
      localStorage.setItem('productType', type)
      this.$store.commit('set_productType', this.optionsValue)
      // 重新加载列，可以清除列头筛选
      this.list()
      this.InitColumn()
    },
    // 将字符串串联成为html
    formatDescribe(row, column, align = 'center') {
      // 拆分字符串为数组
      let arr = String(row[column.property]).split('!#!')
      let i = 0
      switch (column.property) {
        case 'requirementDesc':
        case 'suggestedSolutions':
          return [
            arr.map((item, index) => {
              i++
              return (
                <div style={`text-align:${align};white-space:normal; `} key={index}>
                  <span>
                    {arr.length === 1 && item === '' ? '' : i + '、'}
                    {item}
                  </span>
                </div>
              )
            })
          ]
        case 'userCompany':
        case 'handleNote':
        case 'recorder':
        case 'handler':
        case 'assessNote':
          return [
            arr.map((item, index) => {
              return (
                <div style={`text-align:${align};white-space:normal; `} key={index}>
                  <span>{item}</span>
                </div>
              )
            })
          ]
      }
    },
    // 初始化
    InitColumn() {
      this.gridColumnsMenu = [
        { type: 'seq', width: 40, fixed: 'left' },
        // { title: '序号', field: 'num' },
        // {
        //   title: '产品类型',
        //   field: 'productionType',
        // },
        {
          title: '模块',
          field: 'groupName',
          filters: [
            { data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }
          ],
          filterRender: { name: 'FilterExtend' },
          fixed: 'left'
        },
        {
          minWidth: '120px',
          title: '菜单',
          field: 'vuePath',
          filters: [
            { data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }
          ],
          filterRender: { name: 'FilterExtend' },
          fixed: 'left'
        },
        {
          minWidth: '120px',
          title: '登记单位',
          field: 'userCompany',
          filters: [
            { data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }
          ],
          filterRender: { name: 'FilterExtendCompany' },
          slots: {
            default: ({ row, column }) => {
              return this.formatDescribe(row, column, 'center')
            }
          }
        },
        {
          title: '登记人员',
          field: 'recorder',
          slots: {
            default: ({ row, column }) => {
              return this.formatDescribe(row, column, 'center')
            }
          }
        },
        {
          minWidth: '90px',
          title: '登记日期',
          field: 'recordDate',
          formatter: 'formatDate',
          cellType: 'string',
          filters: [
            { data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        },
        {
          minWidth: '350px',
          title: '需求描述',
          field: 'requirementDesc',
          slots: {
            default: ({ row, column }) => {
              return this.formatDescribe(row, column, 'left')
            }
          }
        },
        {
          minWidth: '150px',
          title: '建议解决方案',
          field: 'suggestedSolutions',
          slots: {
            default: ({ row, column }) => {
              return this.formatDescribe(row, column, 'left')
            }
          }
        },
        {
          title: '处理结果',
          field: 'handleResult',
          filters: [
            { data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '运维人员',
          field: 'handler',
          slots: {
            default: ({ row, column }) => {
              return this.formatDescribe(row, column, 'center')
            }
          }
        },
        {
          minWidth: '90px',
          title: '处理日期',
          field: 'handleTime',
          formatter: 'formatDate',
          cellType: 'string',
          filters: [
            { data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        },
        {
          minWidth: '120px',
          title: '处理说明',
          field: 'handleNote',
          slots: {
            default: ({ row, column }) => {
              return this.formatDescribe(row, column, 'center')
            }
          }
        },
        // {
        //   title: '最终解决方案',
        //   minWidth: '120px',
        //   field: 'solutions'
        // },
        {
          title: '预计更新版本',
          field: 'planIssuedVersion',
          filters: [
            { data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          visible: this.$store.state.userInfo.company === '福州远控',
          title: '更新批次',
          field: 'batchNum',
          filters: [
            { data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '实际更新版本',
          field: 'actualIssuedVersion',
          filters: [
            { data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        { title: '评价', field: 'assessResult' },
        {
          minWidth: '120px',
          title: '评价说明',
          field: 'assessNote',
          slots: {
            default: ({ row, column }) => {
              return this.formatDescribe(row, column, 'center')
            }
          }
        }
      ]
    },
    // 切换查询面板可见性
    changeSearchFormShow() {
      this.searchFormVisible = !this.searchFormVisible
    },
    // 双击数据
    handleDblclick({ row }) {
      this.id = row.id
      // this.form = row
      this.update()
    },
    // 新增前
    async beforeAddOrUpdate(type = 'add') {
      if (!this.$store.state.productType) {
        this.$message.error('您暂未拥有产品类型或未选中产品类型,如有疑问请联系管理员!')
        return
      }
      const { data: res } = await this.$http.get('/Bugs/YKBug/unassess', {
        params: {
          productionType: this.$store.state.productType,
          id: type === 'update' ? this.id : 0
        }
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.tableDataTodo = res.data
      if (res.data.length > 0) {
        // 如果含有未评价明细打开窗口进行评价
        this.$refs.AssessTodoModal.formVisible = true
        return false
      } else {
        // 全部评价完后关闭窗口
        this.$refs.AssessTodoModal.formVisible = false
        return true
      }
    },
    // 新增
    async add() {
      const flag = await this.beforeAddOrUpdate('add')
      if (flag) {
        this.modalType = '新增'
        this.modalId = 0
        this.$refs.AddOrSeeRequireModal.formVisible = true
      }
    },
    // 修改按钮
    async update() {
      if (this.id === 0) {
        this.$message.error('您暂未选中单据，请选择后重试')
        return
      }
      const flag = await this.beforeAddOrUpdate('add')
      if (flag) {
        this.modalType = '修改'
        this.modalId = this.id
        this.$refs.AddOrSeeRequireModal.formVisible = true
      }
    },
    // 删除数据
    delete() {
      // const that = this
      // if (this.id === 0) {
      //   this.$message.error('您暂未选中单据，请选择后重试')
      //   return
      // }
      // if (this.form.writerID !== this.$store.state.userInfo.userId) {
      //   this.$message.error('不可删除他人单据!')
      //   return
      // }
      // this.$confirm('确定要删除本张单据吗？', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      //   .then(async () => {
      //     const { data: res } = await that.$http.delete('/Base/RequirementsGather/' + this.id)
      //     if (!res.isSuccess) {
      //       that.$message.error(res.errorMessage)
      //       return false
      //     }
      //     that.$message.success('删除成功！')
      //     that.list('one')
      //   })
      //   .catch(() => { })
    },
    // 刷新数据
    refresh() {
      if (!this.Authority.see) {
        this.$message.error('您没有相关权限！')
        return
      }
      this.list()
    },
    // 获取数据
    async list() {
      const { data: res } = await this.$http.post('/Bugs/YKBug/list', {
        pageIndex: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize,
        seeType: this.Authority.seeType,
        sqlTitle: this.optionsValue,
        searchObjects: this.searchObjects
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.tableData = res.data.rows
      this.tablePage.total = res.data.totals
    },
    // 修改模态窗类型
    updateModalType(Str) {
      this.modalType = Str
    },
    // 点击导出
    async exp() {
      const that = this
      that.$refs.xTable.exportData({
        filename: '需求登记反馈',
        sheetName: 'Sheet1',
        type: 'xlsx',
        columnFilterMethod({ column }) {
          return column.property !== undefined
        }
      })
    }
  },
  computed: {
    tableHeight() {
      let isSearchForm = this.searchFormVisible
      let isToolBar = true

      // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
      let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
      return this.tableHeightComputed(tableMargin + this.topBottomMargin, isSearchForm, isToolBar)
    },
    // 表格容器高度，需加上margin边距
    approveCardHeight() {
      return this.tableHeight + this.topBottomMargin
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - @header-height);
  overflow: hidden;
}
.card {
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
}
.search-dv {
  background-color: aquamarine;
  height: 100px;
  margin: @main-margin 10px;
}

.toolbar-dv {
  padding: 10px;
}

.table-dv {
  padding: @topBottomMargin;
}

.approve-table-dv {
  display: flex;
  // 行高度，需要比 row-config 的 height 多20px，可以让内容与单元格之间有内边距
  /deep/ .vxe-body--row {
    height: 80px !important;
  }
}
// 角色名称列表
.left-role-dv {
  width: 15%;
  padding: 10px;
}
.role-list-dv {
  width: 100%;
  border-radius: 5px;
  box-shadow: #e2e2e2 0px 0px 3px;
  border: 1px solid #eeeeee;
  overflow: hidden;
  position: relative;
}

// 用户名列表
.middle-user-dv {
  width: 35%;
}
// 权限菜单列表
.menu-dv {
  width: 100%;
}

.vxe-checkbox {
  width: 15px !important;
}
/deep/ .title-dv {
  width: 240px !important;
}
</style>
